import { FC } from 'react';
import Image from 'next/image';
import { MenuBrandContainer } from './MenuLogo.style';
interface Props {
  onClick?: () => void;
}
const MainMenuLogo: FC<Props> = ({
  onClick
}: Props) => {
  return <MenuBrandContainer onClick={onClick}>
            <Image className="desktop" src="/images/menubar/icon-brand-desktop.png" alt="CP-Brandsite" width={176} height={46} priority />
            <Image className="mobile" src="/images/menubar/icon-brand-mobile.png" alt="CP-Brandsite" width={56} height={56} priority />
        </MenuBrandContainer>;
};
export default MainMenuLogo;